import app from './config/configApp';
import router from './routes/protectedRoute';
import store from '@/vuex/store';

import './static/css/style.css';
import '@/core/plugins/ant-design';
import '@/core/plugins/fonts';
import '@/core/plugins/maps';
import '@/core/plugins/masonry';
import '@/core/plugins/apexcharts';
import '@/core/components/custom';
import '@/core/components/style';

import '@/assets/common/css/global.css'
import i18n from "@/lang";
// 完善您现有的错误处理
window.addEventListener('error', (event) => {
    if (event.message && 
        (event.message.includes('ResizeObserver loop limit exceeded') || 
         event.message.includes('ResizeObserver loop') ||
         event.message.includes('ResizeObserver'))) {
        event.preventDefault(); // 阻止错误继续上报或显示在控制台
        console.warn('ResizeObserver loop warning suppressed:', event.message); 
        return true;
    }
    // 其他错误正常处理
});

// 同时也处理 Promise 拒绝错误
window.addEventListener('unhandledrejection', (event) => {
    if (event.reason &&
        event.reason.message &&
        event.reason.message.includes('ResizeObserver loop limit exceeded')) {
        event.preventDefault();
        console.warn('ResizeObserver unhandled rejection suppressed');
    }
});
app.config.productionTip = false;
app.use(store);
app.use(router);
app.use(i18n);
app.mount('#app');
